/*
 * @Author: songxiaoqiang
 * @Date: 2020-08-10 11:33:26
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description: 
 */
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { uploadTrack } from "shihuo-lib/dist/shihuo-lib";
import Aegis from 'aegis-web-sdk';
import '../../../utils/lib-flexible.js';
import getOfflineWebData from '../../../utils/getOfflineWebData';
import utils from '../../../utils/utils.js';

const aegis = new Aegis({
  id: 'vq6qDu47L2vRo3l8XD', //应用ID，即上报key   
  uin: '', // 用户唯一 ID（可选）    
  reportApiSpeed: true, // 接口测速    
  reportAssetSpeed: true, // 静态资源测速    
  spa: true, // spa 应用页面跳转的时候开启 pv 计算
  beforeRequest: (data) => {
    if (typeof window !== 'undefined') {
      const pageScene = window.pageScene;
      const h5Url = window.location.href;
      if (pageScene === 'app首页' || h5Url.indexOf('offlineWeb/page') >= 0) {
        const { logType, logs = {} } = data;
        if (logType === 'performance' || logType === 'vitals') {
          let pageId = '';
          if (h5Url.indexOf('offlineWeb/page') >= 0) {
            const match = h5Url.match(/page\/(\d+)\/version/); 
            if (match) {
              pageId = match[1];
            } else {
              pageId = '';
            }
          } else {
            pageId = utils.getPageId();
          }
          const ua = navigator.userAgent;
          const options = {
            h5Url,
            pageId,
            ua,
            logType,
            logs
          }
          uploadTrack(
            {
              pti: {
                id: 'lego-sales:performance',
                name: '性能指标数据',
                biz: JSON.stringify(options),
                pageOptions: options
              },
            }
          )
          window.Jockey.send('relayPerformanceData', {
            logType,
            logs
          });
        }
      }
    }
    return data;
  }
});
window.aegis = aegis;

// 先加载数据，再渲染应用
async function initApp() {
  if (typeof window !== 'undefined') {
    await getOfflineWebData();
  }
  ReactDOM.render(<App />, document.getElementById('root'));
}

initApp();


// WEBPACK FOOTER //
// ./templates/zhuanti/src/index.js